export const EMBED_START_PATH = "/_agent-native/embed/start";
export const EMBED_TOKEN_QUERY_PARAM = "__an_embed_token";
export const EMBED_MODE_QUERY_PARAM = "embedded";
export const MCP_APP_CHAT_BRIDGE_QUERY_PARAM = "__an_mcp_chat_bridge";
export const EMBED_SESSION_COOKIE = "an_embed_session";
export const EMBED_TARGET_HEADER = "x-agent-native-embed-target";
